<template>
  <div class="active_table">
    <div class="toolbar">
      <div class="bg_tool">
        <div class="search">
          <i-input prefix="ios-search" placeholder="输入查询条件" style="width: auto" />
          <i-button type="default" style="margin-left: 1em;">搜索</i-button>
        </div>
        <div class="active">
          <i-button type="primary">添加</i-button>
          <i-button type="error" style="margin-left: 1em;">批量删除</i-button>
        </div>
      </div>
    </div>
    <div class="table">
      <i-table border :columns="columns" :data="data"></i-table>
      <Page :total="100" show-sizer style="text-align:right;margin-top: 1em" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}
.toolbar {
  width: 100%;
  padding: 3em 1em 1em 1em;
  height: 7.5em;
  .bg_tool {
    display: flex;
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 0.2em 1em;
    border: 1px solid #ccc;
    border-radius: 3.5px;
    justify-content: space-between;
    align-items: center;
  }
}
.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
}
</style>

<script>
export default {
  data() {
    return {
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "Name",
          key: "name"
        },
        {
          title: "Age",
          key: "age"
        },
        {
          title: "Address",
          key: "address"
        }
      ],
      data: [
        {
          name: "John Brown",
          age: 18,
          address: "New York No. 1 Lake Park",
          date: "2016-10-03"
        },
        {
          name: "Jim Green",
          age: 24,
          address: "London No. 1 Lake Park",
          date: "2016-10-01"
        },
        {
          name: "Joe Black",
          age: 30,
          address: "Sydney No. 1 Lake Park",
          date: "2016-10-02"
        },
        {
          name: "Jon Snow",
          age: 26,
          address: "Ottawa No. 2 Lake Park",
          date: "2016-10-04"
        }
      ]
    };
  }
};
</script>